const VERSION="1.8.4";

export { VERSION };
//# sourceMappingURL=data.js.map
